module.exports = __webpack_public_path__ + "static/media/c1.edd2f610.png";